<template>
<div class="modal modal--type-02" v-show="isShow">
<div class="modal__inner">
<form method="post" action="#" name="form-agency" @submit="submit">
<div class="column column--col-2">
<div class="column__inner">

<template v-if="value3 !== '会社員・公務員'">

<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-work-years-01">a. 過去、会社員・公務員であった期間の年数</label></h3>
<div class="form-text">
<input ref="value16" type="text" name="name-dummy-work-years-01" id="label-dummy-work-years-01" placeholder="年数を入力" class="form-text__input" v-model="value16" @blur="changeYearByEvent">
<span class="form-text__unit">年</span></div>
<!-- /.column__col --></div>

<div class="column__col">
<h3 class="heading-label"><label for="label-work-annual-income-01">b. aの期間のおおよその年収（賞与含む）</label></h3>
<div class="form-text">
<input ref="value17" type="text" name="name-work-annual-income-01" id="label-work-annual-income-01" placeholder="金額を入力" class="form-text__input" v-model="value17" @blur="onBlur">
<span class="form-text__unit">万円</span></div>
<!-- /.column__col --></div>

<template v-if="step3SkipFlg">
<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-monthly-income-02">c. <span v-show="value5 === 1">配偶者の</span>直近のおおよその月収（標準報酬月額）</label></h3>
<div class="form-select">
<select name="name-dummy-monthly-income-01" id="label-dummy-monthly-income-02" class="form-select__select" v-model="value22">
<option value="">選択ください</option>
<option value="88000">88千円</option>
<option value="98000">98千円</option>
<option value="104000">104千円</option>
<option value="110000">110千円</option>
<option value="118000">118千円</option>
<option value="126000">126千円</option>
<option value="134000">134千円</option>
<option value="142000">142千円</option>
<option value="150000">150千円</option>
<option value="160000">160千円</option>
<option value="170000">170千円</option>
<option value="180000">180千円</option>
<option value="190000">190千円</option>
<option value="200000">200千円</option>
<option value="220000">220千円</option>
<option value="240000">240千円</option>
<option value="260000">260千円</option>
<option value="280000">280千円</option>
<option value="300000">300千円</option>
<option value="320000">320千円</option>
<option value="340000">340千円</option>
<option value="360000">360千円</option>
<option value="380000">380千円</option>
<option value="410000">410千円</option>
<option value="440000">440千円</option>
<option value="470000">470千円</option>
<option value="500000">500千円</option>
<option value="530000">530千円</option>
<option value="560000">560千円</option>
<option value="590000">590千円</option>
<option value="620000">620千円</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>
</template><!-- 専業主婦・専業主夫 -->

</template><!-- 自営業・専業主婦（夫） -->

<template v-else><!-- 会社員・公務員ここから -->

<div class="column__col">
<h3 class="heading-label">
    <label for="label-dummy-continued-service-years-01">a. これまでの会社員・公務員の勤続年数</label>
</h3>
<div class="form-text">
<input ref="value18" type="text" name="name-dummy-continued-service-years-01" id="label-dummy-continued-service-years-01" placeholder="年数を入力" class="form-text__input" v-model="value18" @blur="changeYearByEvent">
<span class="form-text__unit">年</span></div>
<!-- /.column__col --></div>

<div class="column__col" v-if="value1 < 50">
<h3 class="heading-label"><label for="label-work-annual-income-02">b. aの期間のおおよその年収（賞与含む）</label></h3>
<div class="form-text">
<input ref="value19" type="text" name="name-work-annual-income-02" id="label-work-annual-income-02" placeholder="金額を入力" class="form-text__input" v-model="value19" @blur="onBlur">
<span class="form-text__unit">万円</span></div>
<!-- /.column__col --></div>

<div class="column__col" v-if="value1 >= 50">
<h3 class="heading-label"><label for="label-dummy-mandatory-annual-income-01">b. aの期間のおおよその年収（賞与含む）</label></h3>
<div class="form-text">
<input ref="value20" type="text" name="name-dummy-mandatory-annual-income-01" id="label-dummy-mandatory-annual-income-01" placeholder="金額を入力" class="form-text__input" v-model="value20" @blur="onBlur">
<span class="form-text__unit">万円</span></div>
<!-- /.column__col --></div>

<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-monthly-income-01">c. 直近のおおよその月収（標準報酬月額）</label></h3>

<div class="form-select">
<select name="name-dummy-monthly-income-01" id="label-dummy-monthly-income-01" class="form-select__select" v-model="value21">
<option value="">選択ください</option>
<option value="88000">88千円</option>
<option value="98000">98千円</option>
<option value="104000">104千円</option>
<option value="110000">110千円</option>
<option value="118000">118千円</option>
<option value="126000">126千円</option>
<option value="134000">134千円</option>
<option value="142000">142千円</option>
<option value="150000">150千円</option>
<option value="160000">160千円</option>
<option value="170000">170千円</option>
<option value="180000">180千円</option>
<option value="190000">190千円</option>
<option value="200000">200千円</option>
<option value="220000">220千円</option>
<option value="240000">240千円</option>
<option value="260000">260千円</option>
<option value="280000">280千円</option>
<option value="300000">300千円</option>
<option value="320000">320千円</option>
<option value="340000">340千円</option>
<option value="360000">360千円</option>
<option value="380000">380千円</option>
<option value="410000">410千円</option>
<option value="440000">440千円</option>
<option value="470000">470千円</option>
<option value="500000">500千円</option>
<option value="530000">530千円</option>
<option value="560000">560千円</option>
<option value="590000">590千円</option>
<option value="620000">620千円</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>

</template><!-- 会社員・公務員 -->

<!-- /.column__inner --></div>
<!-- /.column --></div>

<div class="heading-tag">
<h3 class="heading-tag__heading">算出条件</h3>
<!-- /.heading-tag --></div>

<ul class="list-notice" v-if="50 <= value1 && value3 === '会社員・公務員'">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>お客さまからのヒアリング情報に基づき算出しますので、「ねんきん定期便」の情報と同一ではありません。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>老齢基礎年金は、20歳から60歳まで40年間、保険料を納付したとみなして、満額の779,300円といたします。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>60歳まで勤続した場合の老齢厚生年金は、これまでのおおよその年収で60歳まで勤続するものとして、以下の算式に基づいて算出しております。</small></li>
<li class="list-notice__item"><small>これまでの会社員・公務員の期間のおおよその年収（賞与含む）×5.481÷1000×60歳までの勤続年数</small></li>
<!-- /.list-notice --></ul>

<ul class="list-notice" v-else>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>お客さまからのヒアリング情報に基づき算出しますので、「ねんきん定期便」の情報と同一ではありません。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>老齢基礎年金は、20歳から60歳まで40年間、保険料を納付したとみなして、満額の779,300円といたします。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>これまでの加入実績に応じた老齢厚生年金は、以下の算式に基づいて算出しております。</small></li>
<li class="list-notice__item"><small>会社員・公務員の期間のおおよその年収（賞与含む）×5.481÷1000×同左の勤続年数</small></li>
<!-- /.list-notice --></ul>

<div class="button-submit">
<button type="submit" class="button-submit__button" v-if="validateStep2Help">
<span class="button-submit__button-inner">{{btnLabel}}</span>
<!-- /.button-submit__button --></button>
<button type="submit" class="button-submit__button" disabled v-else>
<span class="button-submit__button-inner">{{btnLabel}}</span>
<!-- /.button-submit__button --></button>
<!-- /.button-submit --></div>

<p class="button-close align-center"><button type="button" @click="closeByEvent"><span class="button-close__inner">閉じる</span></button></p>
</form>
<!-- /.modal__inner --></div>
<div class="modal__overlay" @click="closeByEvent"></div>
<!-- /.modal --></div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Utils from '../assets/js/Utils';

    export default {
        name: 'ModalStep2Help',
        props: {
            isShow: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters([
                'value1',
                'value3',
                'value4',
                'value5',
                'validateStep2Help'
            ]),
            step3SkipFlg() {
                return this.value3 === '専業主婦・専業主夫' && this.value4 === '健康保険の被扶養者';
            },
            btnLabel() {
                return this.step3SkipFlg ? 'この内容で試算する' : 'この内容でSTEP3へ';
            },
            value16: {
                get() {
                    return this.$store.getters.value16;
                },
                set(value) {
                    this.changeValue16(value);
                }
            },
            value17: {
                get() {
                    let value = this.$store.getters.value17;

                    // 内部で乗算されているのを元に戻す
                    if (typeof value === 'number' && isFinite(value)) {
                        value /= 10000;
                        value = Utils.addComma(value);
                    }

                    return value;
                },
                set(value) {
                    this.changeValue17(value);
                }
            },
            value18: {
                get() {
                    return this.$store.getters.value18;
                },
                set(value) {
                    this.changeValue18(value);
                }
            },
            value19: {
                get() {
                    let value = this.$store.getters.value19;

                    // 内部で乗算されているのを元に戻す
                    if (typeof value === 'number' && isFinite(value)) {
                        value /= 10000;
                        value = Utils.addComma(value);
                    }

                    return value;
                },
                set(value) {
                    this.changeValue19(value);
                }
            },
            value20: {
                get() {
                    let value = this.$store.getters.value20;

                    // 内部で乗算されているのを元に戻す
                    if (typeof value === 'number' && isFinite(value)) {
                        value /= 10000;
                        value = Utils.addComma(value);
                    }

                    return value;
                },
                set(value) {
                    this.changeValue20(value);
                }
            },
            value21: {
                get() {
                    return this.$store.getters.value21;
                },
                set(value) {
                    this.changeValue21(value);
                }
            },
            value22: {
                get() {
                    return this.$store.getters.value22;
                },
                set(value) {
                    this.changeValue22(value);
                }
            }
        },
        data() {
            return {
                rootElement: null
            };
        },
        watch: {
            isShow(isShow) {
                if (isShow) {
                    this.setFixedClass(true);
                } else {
                    this.setFixedClass(false);
                }
            }
        },
        methods: {
            ...mapActions([
                'changeStep2HelpMode',
                'changeValue16',
                'changeValue17',
                'changeValue18',
                'changeValue19',
                'changeValue20',
                'changeValue21',
                'changeValue22'
            ]),
            submit(event) {
                event.preventDefault();
                this.setFixedClass(false);
                this.$emit('submit', event);
            },
            closeByEvent(event) {
                event.preventDefault();
                this.changeStep2HelpMode(false);
                this.$emit('close', event);
            },
            setFixedClass(isFixed) {
                if (isFixed) {
                    this.rootElement.classList.add('is-fixed');
                } else {
                    this.rootElement.classList.remove('is-fixed');
                }
            },
            changeYearByEvent() {
                if (this.value3 === '会社員・公務員') {
                    this.$refs.value18.value = this.$store.getters.value18;
                } else {
                    this.$refs.value16.value = this.$store.getters.value16;
                }
            },
            onBlur() {
                let valueWithComma = '';
                let value = '';

                if (this.value3 === '会社員・公務員') {
                    if (this.value1 < 50) {
                        value = this.$store.getters.value19;
                    } else {
                        value = this.$store.getters.value20;
                    }
                } else {
                    value = this.$store.getters.value17;
                }

                // 内部で乗算されているのを元に戻す
                if (typeof value === 'number' && isFinite(value)) {
                    valueWithComma = Utils.addComma(value / 10000);
                }

                if (this.value3 === '会社員・公務員') {
                    if (this.value1 < 50) {
                        this.$refs.value19.value = valueWithComma;
                    } else {
                        this.$refs.value20.value = valueWithComma;
                    }
                } else {
                    this.$refs.value17.value = valueWithComma;
                }
            }
        },
        created() {
            this.rootElement = document.documentElement;
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ModalStep2Help.vue